import {setupEntityLog} from '../../common/entity-log';
import {runOnce} from '../../common/run-once';
import {documentReady} from '../../document-ready';

runOnce('helper-entity-log', () => {
    documentReady().then(() => {
        setupEntityLog();
    });
});
